import { RASPBERRY_500, PLUM_500, TEAL_500, BLUE_300, CLEMENTINE_500, YELLOW_500, INK_500 } from 'cio/utils/colors';

export const METRIC_COLORS = [
  { name: 'raspberry-500', value: RASPBERRY_500 },
  { name: 'plum-500', value: PLUM_500 },
  { name: 'teal-500', value: TEAL_500 },
  { name: 'blue-300', value: BLUE_300 },
  { name: 'clementine-500', value: CLEMENTINE_500 },
  { name: 'yellow-500', value: YELLOW_500 },
  { name: 'ink-500', value: INK_500 },
];
